import { VariableType } from 'json-to-graphql-query';

import { Terms } from '@/interfaces/terms';
import { EntityResource } from './entity.resource';
import { FilterArgs, FilterVariables } from './queryVariables/filters/filters';

/**
 * Resource regulaminów
 *
 * @export
 * @class TermsResource
 * @extends {EntityResource<Terms>}
 */
export class TermsResource extends EntityResource<Terms> {
  public getFields = {
    id: true,
    name: true,
    order: true,
    required: true,
    start: true,
    end: true,
    content: true,
    acceptText: true
  };

  public listFields = {
    id: true,
    name: true,
    start: true,
    consents: {
      accepted: true
    }
  };
  protected listVariables = FilterVariables;
  protected listArgs = FilterArgs;

  constructor() {
    super({
      entityName: 'terms'
    });
  }

  /**
   * Pobieranie aktualnych regulaminów
   *
   * @param {string} profileType
   * @returns {Promise<Terms[]>}
   * @memberof TermsResource
   */
  public async termsCurrent(required?: boolean): Promise<Terms[]> {
    const query = this.prepareOptions({
      query: {
        __variables: { required: 'Boolean' },
        termsCurrent: {
          __args: { required: new VariableType('required') },
          id: true,
          name: true,
          order: true,
          required: true,
          start: true,
          content: true,
          acceptText: true
        }
      }
    });
    return this.query(
      {
        query,
        variables: { required }
      },
      'termsCurrent'
    );
  }
}

export const termsResource = new TermsResource();
